<template>
  <div class="width-100">
    <div class="col-lg-12">
      <label for="street">City<span>*</span></label>
      <v-select :placeholder="'Choisir une wilaya'" :options="optionsWilaya" v-model="selectedWilaya"
        @input="setSelectedWilaya" :class="{ 'is-invalid': has_error && errors.delivery_city }" />
      <span class="text-danger help-block" v-if="has_error && errors.delivery_city">{{ errors.delivery_city[0] }}</span>
    </div>
    <div class="col-lg-12 mt-2">
      <label for="street">{{ $t("attr.township") }}<span>*</span></label>
      <v-select :placeholder="'Choisir une commune'" :options="optionsCommune" v-model="selectedCommune"
        @input="setSelectedCommune" :class="{ 'is-invalid': has_error && errors.commune_id }" />
      <span class="text-danger help-block" v-if="has_error && errors.commune_id">{{ errors.commune_id[0] }}</span>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
export default {
  data() {
    return {

      optionsWilaya: [],
      optionsCommune: [],
      selectedWilaya: null,
      selectedCommune: null,
    };
  },
  props: {
    errors: {
      type: Object,
    },
    has_error: {
      type: Boolean,
    },

    value: Object
  },
  beforeMount() {
    this.getWilayas().then(() => {
      this.prefillFromUser();
    });
  },
  methods: {
    async prefillFromUser() {
      const user=this.$parent.user||this.$parent.selectedOrderInformation;
      if (!user) return;

      // 1️⃣ Prefill Wilaya (match by name)
      const wilaya=this.optionsWilaya.find(w => w.label===user.city);

      if (wilaya) {
        this.selectedWilaya=wilaya;
        this.setSelectedWilaya(wilaya);

        //  Load communes for this wilaya
        await this.getCommunesByWilayas(wilaya.value);

        // 2️⃣ Prefill Commune (match by ID)
        const commune=this.optionsCommune.find(c => c.value==user.commune);

        if (commune) {
          this.selectedCommune=commune;
          this.setSelectedCommune(commune);
        }
      }
    },

    setSelectedWilaya(value) {
      this.optionsCommune=[];

      if (this.$route.name==="checkoutOrder") {
        this.$parent.selectedOrderInformation.delivery_city=value.label;
        this.$parent.selectedOrderInformation.wilaya_id=value.value;

        // FIX 👇
        this.$parent.selectedOrderInformation.city=value.label;
      }

      if (this.$route.name==="userProfile") {
        this.$parent.userUpdate.city=value.label;
        this.$parent.userUpdate.wilaya_id=value.value;
      }

      this.getCommunesByWilayas(value.value);
      this.$emit("input", {
        ...this.value,
        city: value.label,      // wilaya name
        wilaya_id: value.value, // wilaya id
      });
    }
    ,

    setSelectedCommune(value) {
      this.selectedCommune=value;

      // Emit to parent (v-model)
      this.$emit("input", {
        ...this.value,
        commune_id: value.value, // ID
        commune: value.value     // Name (if needed)
      });

      // Update parent depending on route
      if (this.$route.name==="checkoutOrder") {
        this.$parent.selectedOrderInformation.commune_id=value.value;
      }

      if (this.$route.name==="userProfile") {
        this.$parent.userUpdate.commune=value.value;
      }
    }
    ,

    getWilayas() {
      return this.$axios.get("getWilaya").then((response) => {
        this.optionsWilaya=response.data.map(w => ({
          value: w.id,
          label: w.name,   // 👈 vue-select uses these keys
        }));
      });
    },

    getCommunesByWilayas(id) {
      return this.$axios.get("getCommunesByWilaya/"+id).then((response) => {
        this.optionsCommune=response.data.map(c => ({
          value: c.id,
          label: c.name,
        }));
      });
    },



  },
};
</script>

<style scoped>
.vs__search {
  margin-bottom: 0 !important;
}
</style>
